'use client';

import React from 'react';
import { OfferCardData } from './types';
import CouponIcon from '../Icons/CouponIcon';
import { formatOfferExpirationDate } from './offerExpirationDate';
import PLPOfferCard, { PLPOfferCardProps } from './PLPOfferCard';

interface OfferCardProps {
  data: OfferCardData;
  onOpen: (offer: OfferCardData) => void;
  variant?: 'default' | 'plp';
  plpProps?: Omit<PLPOfferCardProps, 'data' | 'onOpen'>;
}

const OfferCard: React.FC<OfferCardProps> = ({ data, onOpen, variant = 'default', plpProps }) => {
  if (variant === 'plp') {
    return (
      <PLPOfferCard
        data={data}
        onOpen={onOpen}
        {...plpProps}
      />
    );
  }

  const { title, teaser, linkTitle, expirationDate } = data;
  const formattedExpirationDate = formatOfferExpirationDate(expirationDate);

  return (
    <article className='bg-white rounded-lg border border-border-global transition-colors duration-200 h-full has-[.offer-button:hover]:border-secondary-500 has-[.offer-button:focus-visible]:border-secondary-500'>
      <div className='md:max-w-xl p-8 max-w-full flex flex-col items-start h-full'>
        <div className='flex flex-col items-start gap-6'>
          <CouponIcon className='text-brand-icon w-15 h-15' />

          <h3 className='heading-3'>{title}</h3>

          <p className='copy-medium text-left!'>{teaser}</p>

          <span className='copy-medium text-left!'>Offer expires {formattedExpirationDate}</span>
        </div>

        <div className='mt-auto pt-16'>
          <button
            type='button'
            onClick={() => onOpen(data)}
            className='offer-button relative inline-block cursor-pointer
              heading-6 font-semibold
              after:absolute after:left-0 after:-bottom-2 after:h-0.5 after:w-full
              after:bg-secondary-500 after:transition-all after:duration-200
              hover:after:-bottom-1
              focus:outline-none focus:ring-2 focus:ring-secondary-300 focus:ring-offset-2'
          >
            {linkTitle}
          </button>
        </div>
      </div>
    </article>
  );
};

export default OfferCard;
